import axios, { getAuthHeader } from './client.ts';
import services from './services.ts';

export const ENDPOINTS = {
  CREATE_STRIPE_ACCOUNT: `${services.PAYMENTS}/account`,
  STRIPE_DASHBOARD: `${services.PAYMENTS}/stripe-link`,
  SINGLE_PAYMENT: `${services.PAYMENTS}/singlepayment`,
  SINGLE_PAYMENT_BY_ID: (id: string) => `${services.PAYMENTS}/singlepayment/${id}`,
  SURPRISE_GIFT: `${services.PAYMENTS}/gift`,
  UPDATE_SURPRISE_GIFT: (id: string) => `${services.PAYMENTS}/gift/${id}`,
};

export const createStripeAccount = (token: string, data: Record<string, unknown>) =>
  axios.post(ENDPOINTS.CREATE_STRIPE_ACCOUNT, data, {
    headers: { ...{ 'Content-Type': 'application/json' }, ...getAuthHeader(token) },
  });

export const toStripeDashboard = (token: string) =>
  axios.get(ENDPOINTS.STRIPE_DASHBOARD, {
    headers: { ...{ 'Content-Type': 'application/json' }, ...getAuthHeader(token) },
  });

export const createSinglePayment = (data: Record<string, unknown>, token: string) =>
  axios.post(ENDPOINTS.SINGLE_PAYMENT, data, {
    headers: { ...{ 'Content-Type': 'application/json' }, ...getAuthHeader(token) },
  });

export const getSurpriseGiftPayment = (paymentId: string, token: string) =>
  axios.get(ENDPOINTS.SINGLE_PAYMENT_BY_ID(paymentId), {
    headers: { ...{ 'Content-Type': 'application/json' }, ...getAuthHeader(token) },
  });

export const updateSinglePayment = (paymentId: string, data: Record<string, unknown>, token: string) =>
  axios.put(ENDPOINTS.SINGLE_PAYMENT_BY_ID(paymentId), data, {
    headers: { ...{ 'Content-Type': 'application/json' }, ...getAuthHeader(token) },
  });

export const createSurpriseGiftPayment = (data: Record<string, unknown>, token: string) =>
  axios.post(ENDPOINTS.SURPRISE_GIFT, data, {
    headers: { ...{ 'Content-Type': 'application/json' }, ...getAuthHeader(token) },
  });

export const updateSurpriseGiftPayment = (data: Record<string, unknown>, paymentId: string, token: string) =>
  axios.put(ENDPOINTS.UPDATE_SURPRISE_GIFT(paymentId), data, {
    headers: { ...{ 'Content-Type': 'application/json' }, ...getAuthHeader(token) },
  });
